import {timetable_editTimetableDetailNotes_Api} from 'apis'
import {Button, Input} from 'antd'
import DrawDialog from 'components/drawer/dialog/DrawDialog'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useState} from 'react'
import {PiNotePencilBold} from 'react-icons/pi'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify} from 'views/AppLocals/factory/createNotification'

// DrawDialog (bottom-sheet mobile / popup desktop) sửa nhanh ghi chú của 1 buổi học cụ thể, mirror
// SessionMaterialsDrawer.js - chỉ khác field đơn (notes text tự do) thay vì list link. Notes dùng
// đúng field thật TimetableDetail.notes (đã có sẵn từ trước, admin cũng sửa được qua form Lịch
// trình đầy đủ TimetableForm.js) - đây chỉ là đường tắt sửa tại chỗ ngay trong danh sách buổi học
// (MyClassSessionsPanel.js) mà không cần mở form đầy đủ, dùng cho nội dung tự do quanh buổi học
// (link/lưu ý trước buổi, bài tập về nhà...). Link tài liệu bài giảng có cấu trúc riêng (title+url)
// vẫn đi qua materials ở trên, không gộp vào đây.
const SessionNotesBody = ({session, onSaved, onClose}) => {
    const t = useTranslate()
    const [notes, setNotes] = useState(session?.notes || '')

    useEffect(() => {
        setNotes(session?.notes || '')
    }, [session])

    const {handleAsyncAction: onSave, isLoading} = useAsyncAction({
        apiInfo: timetable_editTimetableDetailNotes_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            if (onSaved) onSaved()
            onClose()
        },
    })

    return (
        <div className="flex flex-col gap-3">
            <Input.TextArea
                rows={4}
                placeholder={t('session notes placeholder')}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
            />
            <div className="flex justify-end gap-2 pt-2 border-t border-color-50">
                <Button onClick={onClose}>{t('cancel')}</Button>
                <Button
                    type="primary"
                    loading={isLoading}
                    onClick={() => onSave({notes: notes.trim() || null}, {id: session?.id})}>
                    {t('save')}
                </Button>
            </div>
        </div>
    )
}

// trigger - override nút mở drawer (mặc định nút text+icon như cũ) - xem comment tương ứng ở
// SessionMaterialsDrawer.js.
export const SessionNotesDrawer = ({session, onRefresh, trigger}) => {
    const t = useTranslate()
    return (
        <DrawDialog
            title={t('manage session notes')}
            width={480}
            component={
                trigger || (
                    <button
                        type="button"
                        title={t('manage session notes')}
                        className="flex items-center gap-1 text-2xs font-medium text-color-400 hover:text-indigo-600 whitespace-no-wrap">
                        <PiNotePencilBold size={11}/>
                        {t('note')}
                    </button>
                )
            }>
            {(isToggle, toggle) => isToggle && (
                <SessionNotesBody session={session} onSaved={onRefresh} onClose={() => toggle(false)}/>
            )}
        </DrawDialog>
    )
}

export default SessionNotesDrawer
